import React from "react";
import fetch from "../../assets/functions/fetch";
import Alert from "../../components/alert";

import config from "../../config.json";
class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      showMessage: false,
      alertMessage: "",
    };

    // if (localStorage.getItem("rememberMe") === true) {
    //   this.props.history.push("/");
    //   return;
    // }
  }
  componentDidMount = () => {};
  componentWillMount = () => {
    document.body.style = `height:100vh;background-color: ${config.navColor};background-image: -webkit-gradient(linear,left top,left bottom,color-stop(10%,${config.navActiveColor}),to(${config.navColor}));background-image: linear-gradient(180deg,${config.navActiveColor} 10%,${config.navColor} 100%);background-size: cover;`;
  };

  componentWillUnmount = () => {
    document.body.style = "";
  };

  submitForm = (e) => {
    e.preventDefault();
    let { username, password } = this.state;

    if (!username || !password) return;
    fetch("/login", {
      method: "post",
      body: { username, password },
      headers: { "Content-Type": "application/json" },
    })
      .then((i) => {
        if (!i) return;
        if (i.error === true) {
          this.setState({ showMessage: true, alertMessage: i.message });
          // this.setState({ showMessage: false, alertMessage: "" });
        } else {
          localStorage.setItem(config.jwtName, i.token);
          window.location.href = config.loginPage;
        }
      })
      .catch((err) => {
        this.setState({ showMessage: true, alertMessage: "Error" });

        // alert(err);
      });
  };

  closePopup = () => {
    this.setState({ showMessage: false });
  };

  render = () => {
    return (
      <React.Fragment>
        <Alert
          showMessage={this.state.showMessage}
          alertMessage={this.state.alertMessage}
          close={this.closePopup}
        />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-10 col-lg-12 col-md-9">
              <div className="card o-hidden border-0 shadow-lg my-5">
                <div className="card-body p-0">
                  <div className="row">
                    <div className="col-lg-6 d-none d-lg-block text-center">
                      <img
                        alt="Login pic"
                        style={{ height: "300px" }}
                        src="http://pluspng.com/img-png/user-png-icon-user-2-icon-png-file-512x512-pixel-512.png"
                      />
                    </div>
                    <div className="col-lg-6">
                      <div className="p-5">
                        <div className="text-center">
                          <h1 className="h4 text-gray-900 mb-4">
                            Welcome Back!
                          </h1>
                        </div>
                        <form>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control form-control-user"
                              placeholder="Enter Username..."
                              onChange={(e) =>
                                this.setState({ username: e.target.value })
                              }
                            />
                          </div>
                          <div className="form-group">
                            <input
                              type="password"
                              className="form-control form-control-user"
                              placeholder="Password"
                              onChange={(e) =>
                                this.setState({ password: e.target.value })
                              }
                            />
                          </div>

                          <button
                            className="btn btn-primary btn-user btn-block"
                            onClick={(e) => this.submitForm(e)}
                            style={{ backgroundColor: config.navActiveColor }}
                          >
                            Login
                          </button>
                          <hr />
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
}

export default Login;
